bankingInfoController.$inject = [
	'$scope',
	'dialogHelper',
	'$q',
	'$uibModal',
	'utilsService',
	'Upload',
	'bankService',
	'siteService',
	'unitService',
	'$filter',
	'authService',
	'USER_CLAIMS',
	'ROLE_CLAIMS',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('bankingInfoController', bankingInfoController);

function bankingInfoController(
	$scope,
	dialogHelper,
	$q,
	$uibModal,
	utilsService,
	Upload,
	bankService,
	siteService,
	unitService,
	$filter,
	authService,
	USER_CLAIMS,
	ROLE_CLAIMS,
	BUSY_MESSAGE
) {
	var fieldClaims = authService.authentication.fieldClaims;
	var hasFieldRestriction = _.findWhere(fieldClaims, {
		ClaimValue: ROLE_CLAIMS.HideBankAccountNumber,
	});

	var displayCancelCheckPrintingButton = _.findWhere(fieldClaims, {
		ClaimValue: ROLE_CLAIMS.PrintChecksOverride,
	});

	var viewModel = getViewModel();

	$scope.setClearedCheckForm = function (event) {
		$scope.clearedCheckForm = event;
	};

	$scope.vm = viewModel;
	$scope.busyPromise = $q.all([
		LoadStates($scope.vm),
		LoadCheckLayout($scope.vm),
		LoadCheckMemoLocation($scope.vm),
		LoadUnit($scope.vm),
		$scope.vm.loadDefaultBankId(),
		$scope.vm.loadBanks($scope.vm),
		$scope.vm.loadSites($scope.vm),
		$scope.vm.loadBankStatuses($scope.model),
	]);

	function getViewModel() {
		var model = {
			hideBankAccounts: hasFieldRestriction !== null,
			banks: [],
			defaultBankId: null,
			bankStatuses: [],
			selectedBank: null,
			backupBank: null,
			sites: [],
			selectedBankSites: null,
			backupBankSites: null,
			numSelectedInBackupBankSites: 0,
			selectedBankSitesPaging: {
				search: '',
				pageSize: 12,
				startIndex: 0,
				numberOfSelectedItems: 0,
				allSelected: false,
			},
			states: [],
			checkMemoLocations: [],
			checkLayouts: [],
			unit: null,
			filter: {
				tab: 'Account',
				search: '',
				sitesToShow: [],
				propertyName: 'ShortName',
				reverse: false,
			},
			pageSize: 12,
			startIndex: 0,
			attachedAccountPageSize: 7,
			attachedAccountStartIndex: 0,
			errors: null,
			busyMessage: BUSY_MESSAGE.Loading,
			isSchoolAccountingActive: authService.isActive(USER_CLAIMS.lsb),
			isPayrollAccessible: false,
			isReadOnly: authService.isReadOnly(USER_CLAIMS.system, 'BankingInfo', 'system'),
			displayPrintCheckOverride: displayCancelCheckPrintingButton !== null && displayCancelCheckPrintingButton !== undefined,
		};

		function toggleSelectAll(model, search, array, filterNone) {
			let cnts = _.countBy(array, function (item) {
				return item.Selected === true ? 'selectedCnt' : 'unselectedCnt';
			});
			let numSelected = _.isUndefined(cnts.selectedCnt) ? 0 : cnts.selectedCnt;
			model.selectedBankSitesPaging.numberOfSelectedItems = numSelected;

			let filterArray = array;
			if (!filterNone) {
				filterArray = $filter('filter')(array, search);
			}

			let foundUnselected = _.find(filterArray, function (item) {
				return item.Selected === false;
			});
			let allSelected = foundUnselected === undefined;

			if (model.filter.tab === 'Sites') model.selectedBankSitesPaging.allSelected = allSelected;
		}

		function selectAllBankSites(model) {
			let setTo;
			if (model.selectedBankSitesPaging.allSelected) {
				setTo = true;
			} else {
				setTo = false;
			}
			for (let index = 0; index < model.selectedBankSites.length; index++) {
				model.selectedBankSites[index].Selected = setTo;
			}
			let cnts = _.countBy(model.selectedBankSites, function (item) {
				return item.Selected === true ? 'selectedCnt' : 'unselectedCnt';
			});
			let numSelected = _.isUndefined(cnts.selectedCnt) ? 0 : cnts.selectedCnt;
			model.selectedBankSitesPaging.numberOfSelectedItems = numSelected;
		}

		function formIsDirty() {
			return (
				$scope.accountForm.$dirty ||
				$scope.addressesForm.$dirty ||
				$scope.checkForm.$dirty ||
				$scope.sitesForm.$dirty ||
				$scope.reconForm.$dirty ||
				($scope.clearedCheckForm && $scope.clearedCheckForm.dirty)
			);
		}

		function buildPatch(model) {
			var patch = _.pick(model.selectedBank, function (value, key, object) {
				return !Array.isArray(model.selectedBank[key]) && model.selectedBank[key] !== model.backupBank[key];
			});
			return patch;
		}

		function changeTab(model, tab) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, null, acceptFunction);

			function acceptFunction() {
				model.filter.tab = tab;
			}
		}

		function save(model) {
			$scope.accountForm.$setSubmitted();
			$scope.addressesForm.$setSubmitted();
			$scope.checkForm.$setSubmitted();
			$scope.cashForm.$setSubmitted();
			$scope.sitesForm.$setSubmitted();
			$scope.reconForm.$setSubmitted();
			if (
				model.isReadOnly ||
				(!$scope.accountForm.$valid && model.filter.tab === 'Account') ||
				(!$scope.addressesForm.$valid && model.filter.tab === 'Addresses') ||
				(!$scope.checkForm.$valid && model.filter.tab === 'Check') ||
				(!$scope.cashForm.$valid && model.filter.tab === 'Cash') ||
				(!$scope.sitesForm.$valid && model.filter.tab === 'Sites')
			)
				return false;

			let associatedSiteIds = _.map(
				model.selectedBankSites.filter(function (value) {
					return value.Selected === true;
				}),
				function (currentObject) {
					return currentObject.Id;
				}
			);

			model.selectedBank.AssociatedSiteIds = associatedSiteIds;
			model.busyMessage = BUSY_MESSAGE.Saving;
			$scope.busyPromise = bankService.saveBank(model.selectedBank).then(_.partial(finishSaving, model));

			function finishSaving(model, response) {
				if (response.data.isValid) {
					model.errors = null;
					$scope.accountForm.$setPristine();
					$scope.addressesForm.$setPristine();
					$scope.checkForm.$setPristine();
					$scope.cashForm.$setPristine();
					$scope.sitesForm.$setPristine();
					$scope.reconForm.$setPristine();
					model.backupBank = angular.copy(model.selectedBank);
					model.backupBankSites = angular.copy(model.selectedBankSites);
					model.numSelectedInBackupBankSites = model.selectedBankSitesPaging.numberOfSelectedItems;
					model.busyMessage = BUSY_MESSAGE.Loading;
					$scope.busyPromise = loadBanks($scope.vm).then(function () {
						model.selectedBankSitesPaging.startIndex = 0;
						return selectBank($scope.vm, model.selectedBank.Id, model.filter.tab);
					});
				} else {
					model.errors = response.data.errors;
					return angular.noop;
				}
			}
		}

		function cancelSave(model) {
			$scope.accountForm.$setPristine();
			$scope.addressesForm.$setPristine();
			$scope.checkForm.$setPristine();
			$scope.cashForm.$setPristine();
			$scope.sitesForm.$setPristine();
			$scope.reconForm.$setPristine();
			$scope.accountForm.$setUntouched();
			$scope.addressesForm.$setUntouched();
			$scope.checkForm.$setUntouched();
			$scope.cashForm.$setUntouched();
			$scope.sitesForm.$setUntouched();
			$scope.reconForm.$setUntouched();
			model.selectedBank = angular.copy(model.backupBank);
			if (model.selectedBank) {
				model.LoadImages(model.selectedBank.Id);
			}
			model.selectedBankSites = angular.copy(model.backupBankSites);
			model.selectedBankSitesPaging.numberOfSelectedItems = model.numSelectedInBackupBankSites;
			model.selectedBankSitesPaging.allSelected =
				model.selectedBankSitesPaging.numberOfSelectedItems === model.selectedBankSites.length ? true : false;
			model.errors = null;
		}

		function uploadFile(model, file, errFiles, imageLocation) {
			$scope.checkForm.$setDirty();

			$scope.f = file;
			$scope.errFile = errFiles && errFiles[0];
			if (file) {
				file.upload = Upload.upload({
					url: '/api/banks/upload',
					method: 'POST',
					data: {
						file: file,
						id: model.selectedBank.Id,
						location: imageLocation,
					},
				});

				file.upload.then(
					function (response) {
						return LoadImages(model, model.selectedBank.Id);
					},
					function (response) {
						if (response.status > 0) model.errors = response.status + ': ' + response.data;
					}
				);
			}
		}

		function selectBank(model, id, tab, forceLoad) {
			if (!forceLoad) {
				return dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, null, acceptFunction);
			} else {
				acceptFunction();
			}

			function acceptFunction() {
				model.busyMessage = BUSY_MESSAGE.Loading;
				$scope.busyPromise = bankService
					.getBank(id)
					.then(_.partial(finishLoadingBank, model))
					.then(function () {
						model.LoadImages(id);
						model.attachedAccountStartIndex = 0;
						return angular.noop;
					});
			}

			function finishLoadingBank(model, response) {
				if (response.data.isValid) {
					model.errors = null;
					model.selectedBank = response.data.bank;
					model.selectedBank.balance = response.data.balance;
					model.selectedBank.canDelete = response.data.canDelete;
					model.backupBank = angular.copy(model.selectedBank);
					//model.filter.tab = 'Account';
					if (tab) {
						model.filter.tab = tab;
					}
					model.selectedBankSites = [];
					model.selectedBankSitesPaging.numberOfSelectedItems = 0;
					for (let index = 0; index < model.filter.sitesToShow.length; index++) {
						let siteIdActive = model.selectedBank.BankSites
							? model.selectedBank.BankSites.filter(function (value) {
									return value.SiteId === model.filter.sitesToShow[index].Id;
							  }).length > 0
							: 0;

						model.selectedBankSites.push({
							SiteName: model.filter.sitesToShow[index].SiteName,
							Id: model.filter.sitesToShow[index].Id,
							Selected: siteIdActive,
						});
						if (siteIdActive) model.selectedBankSitesPaging.numberOfSelectedItems++;
					}
					if (model.selectedBankSitesPaging.numberOfSelectedItems === model.selectedBankSites.length)
						model.selectedBankSitesPaging.allSelected = true;

					model.selectedBankSites = model.selectedBankSites.sort(function (a, b) {
						if (a.Selected === true && b.Selected === false) {
							return -1;
						} else if (a.Selected === false && b.Selected === true) {
							return 1;
						} else {
							if (a.SiteName < b.SiteName) {
								return -1;
							} else if (a.SiteName > b.SiteName) {
								return 1;
							} else {
								return 0;
							}
						}
					});
					model.backupBank = angular.copy(model.selectedBank);
					model.backupBankSites = angular.copy(model.selectedBankSites);
					model.numSelectedInBackupBankSites = model.selectedBankSitesPaging.numberOfSelectedItems;
				} else {
					model.errors = response.data.errors;
				}
				return angular.noop;
			}
		}

		function loadBanks(model) {
			return bankService.getBanks().then(_.partial(finishLoadingBanks, model));

			function finishLoadingBanks(model, response) {
				model.banks = response.data.banks;
				return angular.noop;
			}
		}

		function LoadImages(model, id) {
			$scope.loadingImages = bankService.getImages(id).then(_.partial(finishLoadingImage, model));

			function finishLoadingImage(model, response) {
				model.selectedBank.Signature1Src = response.data.Signature1;
				model.selectedBank.Signature2Src = response.data.Signature2;
				model.selectedBank.Signature3Src = response.data.Signature3;
				model.selectedBank.LogoSrc = response.data.logo;

				return angular.noop;
			}
		}

		function removeImage(model, imageLocation) {
			const removeBankImage = function () {
				$scope.loadingImages = bankService
					.removeImage(model.selectedBank.Id, imageLocation)
					.then(_.partial(model.LoadImages, model.selectedBank.Id));
			};

			const params = {
				mainText: 'Remove Image?',
				detailText: `"${imageLocation}" image will be removed from this Bank.\xa0\xa0\xa0\xa0  Are you sure?`,
				iconType: 'Question',
				acceptButton: {
					text: 'YES',
					func: removeBankImage,
				},
			};

			return dialogHelper.actionDialog(params);
		}

		function deleteBank(model) {
			$uibModal.open({
				template: require('@ajs/templates/system/bank-delete-modal.html'),
				backdrop: 'static',
				keyboard: false,
				scope: $scope,
				controller: [
					'$scope',
					'$uibModalInstance',
					'bankService',
					function ($scope, modalInstance, bankService) {
						angular.extend($scope, {
							cancel: function () {
								modalInstance.close();
							},
							deleteBank: function () {
								bankService
									.deleteBank($scope.vm.selectedBank.Id)
									.then(function (response) {
										if (response.data.isValid) {
											modalInstance.close(response.data.bankId);
										} else {
											$scope.errors = response.data.errors;
										}
									})
									.then(function (bankId) {
										$scope.vm.loadBanks().then(function () {
											$scope.vm.selectedBank = null;
										});
									});
							},
						});
					},
				],
			});
		}

		function addAccountBank(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/system/bank-attachAccount-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					windowClass: 'app-modal-1200Wide',
					controller: [
						'$scope',
						'$uibModalInstance',
						'bankService',
						'accountService',
						'ACCOUNT_TYPES',
						function ($scope, modalInstance, bankService, accountService, ACCOUNT_TYPES) {
							$scope.cashAccounts = [];
							$scope.newAttchedAccounts = angular.copy($scope.vm.selectedBank.Accounts);
							$scope.accountPageSize = 10;
							$scope.accountStartIndex = 0;
							$scope.loadingAccounts = $q.all(LoadAccounts());

							angular.extend($scope, {
								clearSelected: function () {
									_.forEach($scope.cashAccounts, function (acnt) {
										acnt.Selected = false;
									});
									$scope.newAttchedAccounts = [];
								},
								addAttach: function (newAccount) {
									let index = _.map($scope.newAttchedAccounts, function (item) {
										return item.Id;
									}).indexOf(newAccount.Id);
									if (index >= 0) {
										$scope.newAttchedAccounts.splice(index, 1);
									} else {
										$scope.newAttchedAccounts.push(newAccount);
									}
								},
								cancel: function () {
									modalInstance.close();
								},
								attachAccounts: function () {
									bankService
										.addAttachedAccountOnBank(
											$scope.vm.selectedBank.Id,
											_.map($scope.newAttchedAccounts, function (item) {
												return item.Id;
											})
										)
										.then(finishLoadingAccounts);

									function finishLoadingAccounts(response) {
										modalInstance.close('load');
									}
								},
							});

							function LoadAccounts() {
								return accountService.searchCashAccount(0, '', 0).then(finishLoadingAccounts);

								function finishLoadingAccounts(response) {
									$scope.cashAccounts = response.data.accounts;

									_.forEach($scope.cashAccounts, function (acnt) {
										let found = _.find($scope.newAttchedAccounts, function (account) {
											return account.Id === acnt.Id;
										});
										if (found) {
											acnt.Selected = true;
										}
									});
								}
							}
						},
					],
				})
				.result.then(function (load) {
					if (load) {
						model.selectBank(model.selectedBank.Id, 'Cash', true);
					}
				});
		}

		function removeAttachedAccount(model, account, ev) {
			var id = model.selectedBank.Id;

			const removeAccount = function () {
				$scope.loadingImages = bankService.removedAttachedAccountOnBank(id, account.Id).then(_.partial(finishRemovingAttachedAccount, model));
			};

			function finishRemovingAttachedAccount(model, response) {
				model.selectedBank = null;
				model.selectBank(id, 'Cash');
			}

			const params = {
				openFrom: ev.currentTarget,
				mainText: 'Delete attached Cash Account?',
				detailText: `Cash Account "${account.AccountNumber}" will be removed from this Bank.\xa0\xa0\xa0\xa0\xa0\xa0\xa0  Are you sure?`,
				iconType: 'Question',
				acceptButton: {
					text: 'YES',
					func: removeAccount,
				},
			};

			return dialogHelper.actionDialog(params);
		}

		function addBank(model) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, null, acceptFunction);

			function acceptFunction() {
				$uibModal
					.open({
						template: require('@ajs/templates/system/bank-add-modal.html'),
						backdrop: 'static',
						keyboard: false,
						scope: $scope,
						controller: [
							'$scope',
							'$uibModalInstance',
							'bankService',
							function ($scope, modalInstance, bankService) {
								angular.extend($scope, {
									cancel: function () {
										modalInstance.close();
										$scope.bankForm.errors = '';
									},
									save: function () {
										if (!$scope.bankForm.$valid) return false;
										bankService.addBank($scope.newBank).then(function (response) {
											if (response.data.isValid) {
												modalInstance.close(response.data.bankId);
												$scope.bankForm.errors = '';
											} else {
												$scope.bankForm.errors = response.data.errors;
											}
										});
									},
								});
							},
						],
					})
					.result.then(function (bankId) {
						if (bankId) {
							loadBanks($scope.vm).then(function () {
								return selectBank($scope.vm, bankId);
							});
						}
					});
			}
		}

		function sortby(model, propertyName) {
			model.filter.reverse = model.filter.propertyName === propertyName ? !model.filter.reverse : false;
			model.filter.propertyName = propertyName;
		}

		function loadSites(model) {
			return siteService.getSites().then(_.partial(finishedLoadingSites, model));

			function finishedLoadingSites(model, response) {
				model.startIndex = 0;
				for (let index = 0; index < response.data.sites.length; index++) {
					model.filter.sitesToShow.push({
						SiteName: response.data.sites[index].SiteName,
						Id: response.data.sites[index].Id,
						Selected: true,
					});
				}

				model.filter.sitesToShow = model.filter.sitesToShow.sort(function (a, b) {
					if (a.SiteName < b.SiteName) {
						return -1;
					} else if (a.SiteName > b.SiteName) {
						return 1;
					} else {
						return 0;
					}
				});

				return angular.noop;
			}
		}

		function previewCheck(model, prodInitials) {
			$scope.previewName = prodInitials + ' Check ';

			$uibModal.open({
				template: require('@ajs/templates/system/bank-preview-check-modal.html'),
				backdrop: 'static',
				keyboard: false,
				scope: $scope,
				size: 'previewPO',
				controller: [
					'$scope',
					'$q',
					'$uibModalInstance',
					'bankService',
					function ($scope, $q, modalInstance, bankService) {
						$q.all([getPreview($scope.vm)]);

						function getPreview(model) {
							$scope.gettingPreviewPromise = bankService
								.getPreviewCheckImage(model.selectedBank.Id, prodInitials)
								.then(_.partial(finishedGettingPreview, model));

							return angular.noop;

							function finishedGettingPreview(model, response) {
								$scope.previewImage = response.data.images[0].image;
								return angular.noop;
							}
						}

						angular.extend($scope, {
							getPreview: _.partial(getPreview, model),
							cancel: function () {
								modalInstance.close();
							},
						});
					},
				],
			});
		}

		function loadBankStatuses(model) {
			return utilsService.getBankStatuses().then(_.partial(finishLoadingBankStatuses, model));

			function finishLoadingBankStatuses(model, response) {
				model.bankStatuses = response.data.bankStatuses;

				return angular.noop;
			}
		}

		function loadDefaultBankId(model) {
			return unitService.getValue('DefaultBankId').then(_.partial(finishLoadingDefaultBankId, model));

			function finishLoadingDefaultBankId(model, response) {
				if (response.data.value) model.defaultBankId = parseInt(response.data.value);

				return angular.noop;
			}
		}

		function saveDefaultBankId(model, id) {
			model.errors = null;
			return unitService.saveValue('DefaultBankId', id.toString()).then(_.partial(finishSavingDefaultBankId, model));

			function finishSavingDefaultBankId(model, response) {
				if (response.data.isValid) {
					model.defaultBankId = id;
				} else {
					model.errors = response.data.errors;
				}
				return angular.noop;
			}
		}

		function showPositivePayModal(model) {
			$uibModal.open({
				template: require('@ajs/templates/system/bank-positive-pay-modal.html'),
				backdrop: 'static',
				keyboard: false,
				scope: $scope,
				controller: 'positivePaySetupController',
			});
		}

		return angular.extend(model, {
			formIsDirty: formIsDirty,
			save: _.partial(save, model),
			cancelSave: _.partial(cancelSave, model),
			changeTab: _.partial(changeTab, model),
			uploadFile: _.partial(uploadFile, model),
			selectBank: _.partial(selectBank, model),
			loadBanks: _.partial(loadBanks, model),
			LoadImages: _.partial(LoadImages, model),
			removeImage: _.partial(removeImage, model),
			deleteBank: _.partial(deleteBank, model),
			addBank: _.partial(addBank, model),
			removeAttachedAccount: _.partial(removeAttachedAccount, model),
			addAccountBank: _.partial(addAccountBank, model),
			sortby: _.partial(sortby, model),
			loadSites: _.partial(loadSites, model),
			loadBankStatuses: _.partial(loadBankStatuses, model),
			loadDefaultBankId: _.partial(loadDefaultBankId, model),
			saveDefaultBankId: _.partial(saveDefaultBankId, model),
			toggleSelectAll: _.partial(toggleSelectAll, model),
			selectAllBankSites: _.partial(selectAllBankSites, model),
			previewCheck: _.partial(previewCheck, model),
			showPositivePayModal: _.partial(showPositivePayModal, model),
		});
	}

	function LoadStates(model) {
		return utilsService.getStates().then(_.partial(finishLoadingStates, model));

		function finishLoadingStates(model, response) {
			let country = _.find(response.data.states, function (c) {
				if (c.CountryCode === 'US') {
					return c;
				}
			});

			model.states = country.StateCodes;
		}
	}

	function LoadCheckLayout(model) {
		return utilsService.getCheckLayout().then(_.partial(finishLoadingCheckLayouts, model));

		function finishLoadingCheckLayouts(model, response) {
			model.checkLayouts = response.data.checkLayouts;
		}
	}

	function LoadCheckMemoLocation(model) {
		return utilsService.getCheckMemoLocation().then(_.partial(finishLoadingCheckMemoLocations, model));

		function finishLoadingCheckMemoLocations(model, response) {
			model.checkMemoLocations = response.data.checkMemoLocations;
		}
	}

	function LoadUnit(model) {
		return unitService.getUnit().then(_.partial(finishLoadingUnit, model));

		function finishLoadingUnit(model, response) {
			model.unit = response.data.unit;
			return angular.noop;
		}
	}

	var onRouteChangeOff = $scope.$on('$locationChangeStart', _.partial(dialogHelper.routeChange, $scope.vm.formIsDirty, acceptRouteChangeFunction));

	function acceptRouteChangeFunction() {
		onRouteChangeOff(); // Stop listening for location changes
		return angular.noop;
	}
}

angular.module('schoolLinqApp').directive('validateDuplicateBankShortName', function () {
	return {
		scope: {
			bankList: '=',
			bankId: '=',
		},
		require: 'ngModel',
		link: function (scope, elem, attr, ngModel) {
			ngModel.$parsers.unshift(function (value) {
				let bankId = parseInt(scope.bankId);

				let numberOfMatches = scope.bankList.filter(function (row) {
					return row.ShortName.toLowerCase().trim() === value.toLowerCase().trim() && row.Id !== bankId;
				}).length;

				let isValid;

				if (numberOfMatches > 0) {
					isValid = false;
				} else {
					isValid = true;
				}

				ngModel.$setValidity('validateDuplicateBankShortName', isValid);
				return isValid ? value : undefined;
			});
		},
	};
});
